module.exports = __webpack_public_path__ + "img/pr-5.1a008e37.png";